import {get, post } from './http';

//无文件模式，文件转为base64字符串
//登录
export const login = (data) => post(`/sys/mobilelogin`, data);
export const getInfo = (data) => get(`sys/user/info`, data);
export const listbytype = (data) => get(`/sys/user/listbytype`, data);
export const nav = (data) => get(`/sys/menu/nav`, data);
export const listnoreadmsg = (data) => get(`/jfss/message/listnoreadmsg`, data);
export const setreadmsg = (data) => post(`/jfss/message/setreadmsg`, data);


//退出登录
export const logout = (data) => post(`/sys/logout`, data);


//通航信息
export const addCompany = (data) => post('/jfss/generalcompany/save', data);
export const companyList = (params) => get('/jfss/generalcompany/selflist', params);
export const deleteCompany = (data) => post('/jfss/generalcompany/delete', data);
//总航司
export const allCompanyList = (params) => get('jfss/generalcompany/list', params);

//飞行器列表
export const airList = (params) => get('/jfss/aircraft/selflist', params);
export const addAir = (data) => post('/jfss/aircraft/save', data);
export const deleteAir = (data) => post('/jfss/aircraft/delete', data);

//产权人
export const propertyList = (params) => get('/jfss/propertyowner/selflist', params);
export const addProperty = (data) => post('/jfss/propertyowner/save', data);
export const deleteProperty = (data) => post('/jfss/propertyowner/delete', data);

//高管
export const adminList = (params) => get('/jfss/manager/selflist', params);
export const addAdmin = (data) => post('/jfss/manager/save', data);
export const deleteAdmin = (data) => post('/jfss/manager/delete', data);

//飞行员
export const pilotList = (params) => get('/jfss/pilot/selflist', params);
export const addPilot = (data) => post('/jfss/pilot/save', data);
export const deletePilot = (data) => post('/jfss/pilot/delete', data);



//任务
export const flightTaskList = (params) => get('/jfss/flightmission/list', params);
export const addFlightTask = (data) => post('/jfss/flightmission/save', data);
export const getTaskDetail = (params) => get('/jfss/flightmission/info/' + params);
export const delFlightTask = (data) => post('/jfss/flightmission/delete', data);
export const editFlightTask = (data) => post('/jfss/flightmission/update', data);

//提交任务
export const submitflightmissiontoarmy = (data) => post('/jfss/api/submitflightmissiontoarmy', data);


//计划
export const flightPlanList = (params) => get('/jfss/flightplan/list', params);
export const addFlightPlan = (data) => post('/jfss/flightplan/save', data);
export const getPlanDetail = (params) => get('/jfss/flightplan/info/' + params);
export const delFlightPlan = (data) => post('/jfss/flightplan/delete', data);
export const editFlightPlan = (data) => post('/jfss/flightplan/update', data);

export const updatestatus = (data) => post('/jfss/flightplan/updatestatus', data); //计划状态的改变
export const revoke = (data) => post('/jfss/flightplan/revoke', data);

export const listbyplanid = (data) => post('/jfss/process/listbyplanid', data);

//提交计划
export const submitFlightPlan = (data) => post('/jfss/api/submitflightplan', data);

export const sendplantoofficial = (params) => post('/jfss/flightplan/sendplantoofficial', params); //计划提交到空管分局  测试不用

//获取计划流程
export const getplanprocess = (params) => post('/jfss/api/getplanprocess', params);

// 放行申请
export const updateflystatus = (params) => post('/jfss/flightplan/updateflystatus', params);
export const flyapplysendto = (params) => post('/jfss/flightplan/flyapplysendto', params);



//起降点
export const landingpointList = (params) => get('/jfss/landingpoint/selflist', params);
export const addLandingpoint = (data) => post('/jfss/landingpoint/save', data);
export const editLandingpoint = (data) => post('/jfss/landingpoint/update', data);
export const delLandingpoint = (data) => post('/jfss/landingpoint/delete', data);
export const getLandingpointDetail = (params) => get('/jfss/landingpoint/info/' + params);


//航线
export const lineList = (params) => get('/jfss/route/selflist', params);
export const addLine = (data) => post('/jfss/route/save', data);
export const getLineDetail = (params) => get('/jfss/route/info/' + params);
export const updateLine = (data) => post('/jfss/route/update', data);
export const deleteLine = (data) => post('/jfss/route/delete', data);

//圆形
export const cirList = (params) => get('/jfss/roundarea/selflist', params);
export const addCir = (data) => post('/jfss/roundarea/save', data);
export const getCirDetail = (params) => get('/jfss/roundarea/info/' + params);
export const updateCir = (data) => post('/jfss/roundarea/update', data);
export const deleteCir = (data) => post('/jfss/roundarea/delete', data);


//多边形
export const sqList = (params) => get('/jfss/polygonarea/selflist', params);
export const addSq = (data) => post('/jfss/polygonarea/save', data);
export const getSqDetail = (params) => get('/jfss/polygonarea/info/' + params);
export const updateSq = (data) => post('/jfss/polygonarea/update', data);
export const deleteSq = (data) => post('/jfss/polygonarea/delete', data);

//常用
export const updateflagSq = (data) => post('/jfss/polygonarea/updateflag', data);
export const updateflagLine = (data) => post('/jfss/route/updateflag', data);
export const updateflagCir = (data) => post('/jfss/roundarea/updateflag', data);


//首页
//获取今日计划
export const getTodaylist = (params) => get('/jfss/flightplan/todaylist', params);

//计划放行申请
export const flyapply = (params) => post('/jfss/api/flyapply', params);
//起飞
export const flystart = (params) => post('/jfss/api/flystart', params);
//降落
export const flystop = (params) => post('/jfss/api/flystop', params);

// adsb
export const aircraftcompletemessages = (params) => post('/aircraftmonitoring/aircraftcompletemessage/aircraftcompletemessages', params, true);
//根据ICAO查询最新一条ADS-B数据
export const latestaircraftcompletemessage = (params) => post('/aircraftmonitoring/aircraftcompletemessage/latestaircraftcompletemessage', params, true);


// 气象
export const getMeteoToken = (data) => post('/getMeteoToken', data);


//动态空域列表
export const dynamicairspace = (data) => get('/jfss/dynamicairspace/listall', data);

//告警区域
export const saveMonitoringArea = (data) => post('/jfss/dynamicpolygon/saveMonitoringArea', data);
export const dynamicpolygon = (data) => get('/jfss/dynamicpolygon/monitoringAreaPageList', data);
export const dynamicpolygonInfo = (data) => get('/jfss/dynamicpolygon/info/' + data);
export const updateMonitoringArea = (data) => post('/jfss/dynamicpolygon/updateMonitoringArea', data);
export const delMonitoringArea = (data) => post('/jfss/dynamicpolygon/delete', data);


//自定义航线列表
export const customRouteList = (data) => get('/jfss/dynamicroute/customRoutePageList', data);
export const dynamicroutedelete = (data) => post('/jfss/dynamicroute/delete', data);
export const updateCustomRoute = (data) => post('/jfss/dynamicroute/updateCustomRoute', data);
export const saveCustomRoute = (data) => post('/jfss/dynamicroute/saveCustomRoute', data);
export const dynamicrouteInfo = (data) => get('/jfss/dynamicroute/info/' + data);



//机场列表
export const listbyposition = (data) => get('/jfss/airport/listbyposition', data);
export const airportinfo = (data) => get('/jfss/airportinfo/info/' + data);
export const saveairport = (data) => post('/jfss/airport/save', data);
export const updateairport = (data) => post('/jfss/airport/update', data);
export const deleteairport = (data) => post('/jfss/airport/delete', data);
export const saveairportinfo = (data) => post('/jfss/airportinfo/save', data);
export const updateairportinfo = (data) => post('/jfss/airportinfo/update', data);




//航空情报
export const airmennoticelist = (data) => get('/jfss/airmennotice/list', data);
export const saveairmennotice = (data) => post('/jfss/airmennotice/save', data);
export const updateairmennotice = (data) => post('/jfss/airmennotice/update', data);
export const delairmennotice = (data) => post('/jfss/airmennotice/delete', data);


//航路航线
export const airlinelist = (data) => post('/maplayer/routeline/airlinelist', data);
export const airroutelist = (data) => post('/maplayer/routeline/airroutelist', data);


//管制区
export const monitoringAreaList = (data) => get('/jfss/flightplan/getBranchAirportMsg', data);
export const monitoringRoundList = (data) => get('/jfss/dynamicround/monitoringRoundList', data);

//湖南机场管制室
export const HNJCGZQmonitoringAreaList = (data) => get('/jfss/dynamicpolygon/monitoringAreaList', data);

//低空目视
export const lowaltituderoutelist = (data) => get('/maplayer/routeline/lowaltituderoutelist', data);
export const lowaltituderouteflaglist = (data) => get('/maplayer/routeline/lowaltituderouteflaglist', data);


//动态空域
export const curlist = (params) => get('/jfss/dynamicairspace/curlist', params);

//数据列表
export const getAllAirspaceData = (data) => get(`/jfss/dynamicairspace/listall`, data);
export const getTreeAirspaceData = (data) => get(`/jfss/dynamicairspace/treelist`, data);

//修改
export const editAirspace = (data) => post(`/jfss/dynamicairspace/updatestatus`, data);
//发布
export const pushAirspace = (data) => post(`/jfss/dynamicairspace/publishstatus`, data);

//计划关联空域
export const getDynamicAreaByPlanid = (data) => post(`jfss/flightplan/getDynamicAreaByPlanid`, data);

// 飞行任务与计划冲突告警
export const flyandplayconflict = (data) => post('/jfss/flightplan/getAirspaceAlarmMsg', data);


//放行·申请·详细·信息·
export const nextProcessDetailMessage = (data) => get('/jfss/flightplanapply/info/' + data);

//计划关联机场管制区信息
export const getAirportControlZoneByPlanid = (data) => post('/jfss/flightplan/getAirportControlZoneByPlanid', data);

// 告警席位
export const getcuralarmdatas = (data) => get(`/aircraftmonitoring/aircraftcompletemessage/getcuralarmdatas`, data);
export const flynum = (data) => get(`/aircraftmonitoring/aircraftcompletemessage/flynum`, data);


// 告警历史列表
export const aircraftzonealarm = (data) => get(`/alarm/aircraftzonealarm/list`, data);
export const aircraftdisappearalarm = (data) => get(`/alarm/aircraftdisappearalarm/list`, data);
export const aircraftdistancealarm = (data) => get(`/alarm/aircraftdistancealarm/list`, data);


export const getRequestPlanTypeById = (data) => post('jfss/flightplan/getRequestPlanTypeById', data);
export const clientip = (data) => get('sys/user/clientip', data);
export const getflightplanbysn = (data) => get('aircraftmonitoring/aircraftcompletemessage/getflightplanbysn', data);